import React, {Fragment} from 'react';
import {TextField} from 'material-ui';
import {Elements} from './../ScreenElements/Elements';
import Tooltips from './../Tooltips';
import Checkbox from './../Checkbox';

export default class ElementProperties extends React.Component {
	
	get experiment(){ return this.props.experiment; }
	get screen(){ return this.props.experiment.currentScreen; }
	
	render(){
		let element = this.experiment.currentElement;
		if(!element){ return null; }
		let Properties = Elements[element.type].Properties;
		return (
			<div style={{margin:'0 0px'}}>
				{!!element && 
				<Fragment>
					<Properties element={element} experiment={this.experiment} />
				</Fragment>
				}
			</div>
		);
	}
}

const SimpleValue = ({label, field, className, element, experiment, tooltipId, ...props}) => (
	<TextField
		label={<span>{label} <Tooltips id={tooltipId} /></span>}
		className={`ElementProperty ${className}`}
		value={element[field] || ''}
		onChange={ e => { element[field] = e.currentTarget.value; experiment.forceUpdate(); } }
		margin="normal"
		InputLabelProps={{ shrink: true }}
		{...props}
	/>
)

const Options = ({label, field, className, element, experiment, tooltipId, ...props}) => (
	<TextField
		label={<span>{label} <Tooltips id={tooltipId} /></span>}
		className={`ElementProperty ${className}`}
		value={(element[field] || ['']).join('\n')}
		onChange={ e => { element[field] = e.currentTarget.value.split('\n'); experiment.forceUpdate(); } }
		margin="normal"
		multiline
		rows="5"
		InputLabelProps={{ shrink: true }}
		{...props}
	/>
)

const BooleanValue = ({label, field, className, element, experiment, tooltipId, ...props}) => (
	<Checkbox
		className={`ElementProperty ${className}`}
		label={<span>{label} <Tooltips id={tooltipId} /></span>}
		checked={!!element[field]}
		onChange={ e => { element[field] = e.currentTarget.checked; experiment.forceUpdate(); } }
		{...props}
	/>
)


const onClickAreaHandler = ({props, elementType},  e) => {
	let {left, top} = e.currentTarget.getBoundingClientRect();
	let x = e.clientX - left;
	let y = e.clientY - top;
	props.element.value={x,y};

	props.experiment.recordEvent({eventType:'User Action', actionType:'click', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:elementType,  value: `${x},${y}` });

	onClickHandler({props});
}

const onClickHandler = ({props, field='onClick'}) => {
	if(props.builder){
		return;
	}

	if(props.element[field] === '{finish}'){
		props.experiment.finish();
		return;
	}
	if(props.element[field] === '{next}'){
		props.experiment.next();
		return;
	}
	
	props.experiment.forceUpdate();
	
};

const getMediaURL = ({props}) => {
	let experimentFileUrl = props.experiment.app.mediaManager.indexedFiles[props.element.url];
	return experimentFileUrl ? experimentFileUrl : props.element.url;
};


const Props = {
	Id:      props => (<SimpleValue label='ID' field='id' tooltipId='elementId' fullWidth {...props} />),
	X:       props => (<SimpleValue label='X' field='x'  style={{width:'52px', marginRight:'10px'}} {...props} />),
	Y:       props => (<SimpleValue label='Y' field='y' style={{width:'52px', marginRight:'10px'}} {...props} />),
	Width:   props => (<SimpleValue label='WIDTH' field='width' style={{width:'52px', marginRight:'10px'}} {...props} />),
	Height:  props => (<SimpleValue label='HEIGHT' field='height' style={{width:'52px'}} {...props} />),
	Text:    props => (<SimpleValue label='TEXT' field='text' fullWidth multiline {...props} />),
	Label:    props => (<SimpleValue label='LABEL' field='label' fullWidth {...props} />),
	Expected: props => (<SimpleValue label='EXPECTED' tooltipId='expectedValue' field='expected' fullWidth {...props} />),
	URL:     props => (<SimpleValue label='IMAGE ID OR URL' tooltipId='elementURL' field='url' fullWidth {...props} />),
	OnClick: props => (<SimpleValue label='OnClick' field='onClick' tooltipId='onClick' style={{width:'100px'}} {...props} />),
	OnEnd: props => (<SimpleValue label='OnEnd' field='onEnd' tooltipId='elementOnEnd' style={{width:'100px'}} {...props} />),
	ShowControls: props => (<BooleanValue label='Show Controls' field='showControls' {...props} />),
	AutoPlay: props => (<BooleanValue label='Autoplay' field='autoPlay' {...props} />),
	AutoFocus: props => (<BooleanValue label='Auto Focus' field='autoFocus' {...props} />),
	SubmitOnEnter: props => (<BooleanValue label='Submit on Enter key' field='submitOnEnter' {...props} />),

	Rows:   props => (<SimpleValue label='ROWS' field='rows' {...props} />),
	Options:  props => (<Options label='OPTIONS (one per line)' tooltipId='elementOptions' field='options' fullWidth {...props} />),
	
	onClickAreaHandler: onClickAreaHandler,
	onClickHandler: onClickHandler,
	getMediaURL: getMediaURL,
}

export { Props }; 


// WEBPACK FOOTER //
// ./src/components/Builder/ElementProperties.js